<template>
  <div class="dashboard-editor-container">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span style="font-weight: bolder">快捷导航</span>
        </div>
        <el-row :gutter="32">
          <el-col :xs="3" :sm="4" :lg="3" v-hasPermi="['card:list']">
            <div class="card-panel" @click="handleRoute('/device/cards')">
              <div class="card-panel-icon-wrapper icon-card">
                <span>
                  <svg-icon icon-class="card" class-name="card-panel-icon" />
                </span>
                <span>流量卡管理</span>
              </div>
            </div>
          </el-col>
          <el-col :xs="3" :sm="4" :lg="3" v-hasPermi="['card:list']">
            <div class="card-panel" @click="handleRoute('/order/replacementList')">
              <div class="card-panel-icon-wrapper icon-add-card">
                <span>
                  <svg-icon icon-class="add-card" class-name="card-panel-icon" />
                </span>
                <span>补卡管理</span>
              </div>
            </div>
          </el-col>
          <el-col :xs="3" :sm="4" :lg="3" v-hasPermi="['order:list']">
            <div class="card-panel" @click="handleRoute('/order/orderlist')">
              <div class="card-panel-icon-wrapper icon-order">
                <span>
                  <svg-icon icon-class="order-setting" class-name="card-panel-icon" />
                </span>
                <span>订单管理</span>
              </div>
            </div>
          </el-col>
          <el-col :xs="3" :sm="4" :lg="3" v-hasPermi="['order:commission:list']">
            <div class="card-panel" @click="handleRoute('/order/commission')">
              <div class="card-panel-icon-wrapper icon-commission">
                <span>
                  <svg-icon icon-class="order-commission" class-name="card-panel-icon" />
                </span>
                <span>佣金管理</span>
              </div>
            </div>
          </el-col>
          <el-col :xs="3" :sm="4" :lg="3">
            <div class="card-panel" @click="handleRoute('/authentication/auths')">
              <div class="card-panel-icon-wrapper icon-auth">
                <span>
                  <svg-icon icon-class="authentication" class-name="card-panel-icon" />
                </span>
                <span>实名管理</span>
              </div>
            </div>
          </el-col>
          <el-col :xs="3" :sm="4" :lg="3">
            <div class="card-panel" @click="handleRoute('/order/invoiceManage')">
              <div class="card-panel-icon-wrapper icon-invoice">
                <span>
                  <svg-icon icon-class="invoice" class-name="card-panel-icon" />
                </span>
                <span>发票管理</span>
              </div>
            </div>
          </el-col>
          <el-col :xs="3" :sm="4" :lg="3">
            <div class="card-panel" @click="handleRoute('/device/controlCard')">
              <div class="card-panel-icon-wrapper icon-control-card">
                <span>
                  <svg-icon icon-class="control-card" class-name="card-panel-icon" />
                </span>
                <span>风控管理</span>
              </div>
            </div>
          </el-col>
          <el-col :xs="3" :sm="4" :lg="3">
            <div class="card-panel"  @click="handleRoute('/taskCenter/missionList')">
              <div class="card-panel-icon-wrapper icon-task">
                <span>
                  <svg-icon icon-class="job" class-name="card-panel-icon" />
                </span>
                <span>任务中心</span>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-card>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span style="font-weight: bolder">投诉管理</span>
                <el-link style="margin-left:20px" type="primary" :underline="false" @click="handleComplaintsRoute">去处理</el-link>
                <!-- <el-button type="text" style="margin-left:20px" @click="handleComplaintsRoute">去处理</el-button> -->
              </div>
              <div class="processingData">
                <div class="processingData-left">
                  <div class="shuju">
                    <p class="p1">待处理</p>
                    <p class="p2">
                      <span style="font-size: 40px;color: #659ad2;font-weight: 700;">{{complainData.pendingCount}}</span>
                      <span style="font-size: 16px;color: #659ad2;font-weight: 700;">单</span>
                    </p>
                  </div>
                  <div class="shuju">
                    <p class="p1">处理中</p>
                    <p class="p2">
                      <span style="font-size: 40px;color: #659ad2;font-weight: 700;">{{complainData.processingCount}}</span>
                      <span style="font-size: 16px;color: #659ad2;font-weight: 700;">单</span>
                    </p>
                  </div>
                  <div class="shuju">
                    <p class="p1">今日已处理</p>
                    <p class="p2" style="border:none">
                      <span style="font-size: 40px;color: #333;font-weight: 700;">{{complainData.processedCount}}</span>
                      <span style="font-size: 16px;color: #333;font-weight: 700;">单</span>
                    </p>
                  </div>
                </div>
                <div class="processingData-right"> 
                  <p>
                    <span>未处理售后时长：</span>
                    <span>{{complainData.lastPendingTime + "h"}}</span>
                  </p>
                  <p>
                    <span>处理售后及时率：</span>
                    <span>100%</span>
                  </p>
                  <p>
                    <span>售后率：</span>
                    <span>100%</span>
                  </p>
                </div>
              </div>
          </el-card>
        </el-col>
      </el-row>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span style="font-weight: bolder">共享流量池管理</span>
        </div>
        <!-- 使用 flex 布局容器 -->
        <div class="flex-container">
          <div class="flex-item" v-for="item in sourceFlow" :key="item.groupId">
            <el-card class="box-card">
              <div slot="header" class="clearfix header-container">
                <div class="title-wrapper">
                  <el-tooltip :content="item.groupName" placement="top">
                      <span class="main-title">{{item.groupName}}</span>
                    </el-tooltip>
                  <span class="sub-title">{{item.groupId}}</span>
                </div>
                <svg-icon class="refresh-icon" icon-class="refresh" class-name="icon-refresh" @click.prevent="handleSmallCardCountRefresh(item.groupId)"/>
              </div>
              <customerFlow :groupId="item.groupId" :ref="item.groupId"></customerFlow>
            </el-card>
          </div>
          <!-- 可按需添加更多图表 -->
        </div>
      </el-card>
      
      <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span style="font-weight: bolder">补卡列表</span>
            <el-button type="text" style="margin-left:20px" @click="handleCardRoute">去处理</el-button>
          </div>
          <el-table :data="dataNewCards" border>
            <el-table-column prop="orderNum" label="订单号" align="center" min-width="200px" fixed></el-table-column>
            <el-table-column prop="companyName" label="代理商" align="center" min-width="180px" :show-overflow-tooltip="true" fixed></el-table-column>
            <el-table-column prop="iccid" label="旧ICCID" align="center" min-width="180px">
              <template slot-scope="{row}">
                <el-link type="primary" :underline="false" @click="jumpButton(row.iccid)">{{row.iccid}}</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="orderMoney" label="价格" align="center"></el-table-column>
            <el-table-column prop="phone" label="收货手机号" align="center" min-width="120px"></el-table-column>
            <el-table-column prop="orderPhone" label="支付手机号" align="center" min-width="120px"></el-table-column>
            <el-table-column prop="orderStatus" label="状态" align="center" min-width="160px">
              <template slot-scope="{row}">
                <el-tag v-if="row.orderStatus == '3'">已到账</el-tag>
                <el-tag v-else-if="row.orderStatus =='1'" type="danger">未支付</el-tag>
                <el-tag v-else-if="row.orderStatus =='4'" type="warning">已退款</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="发货状态" align="center">
              <template slot-scope="{row}">
                <el-tag v-if="row.status == '1'" type="warning">未发货</el-tag>
                <el-tag v-else type="success">已发货</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="申请时间" align="center" min-width="185px"></el-table-column>
            <el-table-column prop="orderTime" label="支付时间" align="center" min-width="185px"></el-table-column>
          </el-table>
      </el-card>

      <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span style="font-weight: bolder">国际卡申请列表</span>
            <el-button type="text" style="margin-left:20px" @click="handleApplicationInternationalCardRoute">去处理</el-button>
          </div>
          <el-table :data="dataInternationalCards" border>
            <el-table-column prop="orderNum" label="订单号" align="center" min-width="200px" fixed></el-table-column>
            <el-table-column prop="contactMan" label="联系人" align="center" min-width="120" :show-overflow-tooltip="true">
              <template slot-scope="{row}">
                <span v-if="row.type == '2'">{{row.email || '-'}}</span>
                <span v-else>{{row.contactMan || '-'}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="type" label="类型" align="center" min-width="80">
              <template slot-scope="{row}">
                  <el-tag v-if="row.type == '1'">SIM</el-tag>
                  <el-tag type="success" v-else-if="row.type == '2'">ESIM</el-tag>
                  <el-tag type="info" v-else>未知 </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="状态" align="center" min-width="80">
              <template slot-scope="{row}">
                <template v-if="row.type == '2'">
                  <el-tag type="warning" v-if="row.status == '0'">发送失败</el-tag>
                  <el-tag  v-if="row.status == '1'">发送中</el-tag>
                  <el-tag type="success" v-if="row.status == '2'">已发送</el-tag>
                  <el-tag type="danger" v-if="row.status == '3'">已退款</el-tag>
                </template>
                <template v-else>
                  <el-tag type="warning" v-if="row.status == '0'">未发货</el-tag>
                  <el-tag  v-if="row.status == '1'">待发货</el-tag>
                  <el-tag type="success" v-if="row.status == '2'">已发货</el-tag>
                  <el-tag type="danger" v-if="row.status == '3'">已退款</el-tag>
                </template>
              </template>
            </el-table-column>
            <el-table-column prop="cardNum" label="总卡数/成功数" align="center" min-width="100" :show-overflow-tooltip="true">
              <template slot-scope="{row}">
                {{row.cardNum || '0'}}/{{row.actualNum || '0'}}

              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" align="center" min-width="120">
              <template slot-scope="scope">
                <span>{{ parseTime(scope.row.createTime,'{y}-{m}-{d} {h}:{i}') }}</span>
              </template>
            </el-table-column>
          </el-table>
      </el-card>

      <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span style="font-weight: bolder">发票列表</span>
          </div>
          <el-table :data="dataInvoices" border>
            <el-table-column prop="alias" label="ICCID/代理商" align="center" width="200px" ></el-table-column>
            <el-table-column prop="createTime" label="申请时间" align="center"></el-table-column>
            <el-table-column prop="money" label="发票金额" align="center" width="100px"></el-table-column>
            <el-table-column prop="titleType" label="抬头类型" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.titleType == '1'"> 企业单位</span>
                <span v-else> 个人/事业单位</span>
              </template>
            </el-table-column>
            <el-table-column prop="type" label="发票类型" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.type == '1'"> 电子普通发票</span>
                <span v-else> 增值税专用发票</span>
              </template>
            </el-table-column>
            <el-table-column prop="invoiceInformation" label="发票信息" align="center" width="300px">
              <template slot-scope="scope">
                <p class="invoiceInformation-p">抬头：{{scope.row.title}}</p>
                <p class="invoiceInformation-p">税号：{{scope.row.ein}}</p>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="发票状态" align="center">
              <template>
                审核中
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" fixed="right" width="150">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" plain icon="el-icon-view" v-hasPermi="['order:invoice:detail']" @click="auditInvoice(scope.row)" >审核</el-button>
              </template>
            </el-table-column>
          </el-table>
      </el-card>
  </div>
</template>

<script>
import { complainCount } from "@/api/api.js"; //获取投诉率的数据
import { changeList } from "@/api/api.js"; //补卡列表
import { internationalApplicationList } from "@/api/international.js"; //国际申请卡
import { invoiceList , sourceShareFlow} from "@/api/api.js"; //发票列表
import customerFlow from "@/components/dashboard/customerFlow.vue";
export default {
  name:'customerIndex',
  components: { 
    customerFlow,
  },
  data() {
    return {
      complainData:{},
      dataNewCards:[],
      dataInternationalCards:[],
      dataInvoices:[],
      sourceFlow:[]
    }
  },
  computed: {
    
  },
  methods: {
    handleRoute(path){
      this.$router.push(path);
    },
    // 获取投诉率的数据
    handleComplaint(){
      complainCount().then(res=>{
        this.complainData = res.data.data;
      })
    },
    initNewCards(){
      let params = {
        model:{
          orderStatus:'3',
          status:'1'
        },
        page: 1,
        pageSize: 10
      }
      changeList(params).then(res => {
        this.dataNewCards = res.data.data.records;
      })
    },
    //国际申请卡
    initInternationalApplicationCards(){
      let params = {
        model:{
          status:'1'
        },
        page: 1,
        pageSize: 10
      }
      internationalApplicationList(params).then(res => {
        this.dataInternationalCards = res.data.data.records;
      })
    },
    initInvoiceList(){
      let params = {
        model:{
          status:['1'],
        },
        page: 1,
        pageSize: 10,
      }
      invoiceList(params).then(res=>{
        this.dataInvoices = res.data.data.records;
      })
    },
    handleComplaintsRoute(){
      this.$router.push(`user/complaints`);
    },
    handleCardRoute(){
      this.$router.push(`order/replacementList`);
    },
    handleApplicationInternationalCardRoute(){
      this.$router.push(`international/internationalApplicationList`);
    },
    jumpButton(iccid){
      this.$router.push({path:"/card/detail",query:{iccid: iccid}});
    },
    auditInvoice(row){
      this.$router.push('/order/invoiceDetail/'+row.id);
    },
    handleSmallCardCountRefresh(groupId){
      if (this.$refs[groupId]) {
        this.$refs[groupId][0].smallFlow();
      }
    },
    selectSourceFlow(){
      sourceShareFlow().then(res=>{
        this.sourceFlow = res.data.data
      })
    }
  },
  created(){
    this.handleComplaint();
    this.initNewCards();
    this.initInternationalApplicationCards();
    this.initInvoiceList();
    this.selectSourceFlow()
  }
}
</script>

<style lang="scss" scoped>

.dashboard-editor-container {
  padding: 32px;
  background-color: rgb(240, 242, 245);
  position: relative;

  .box-card{
    background-color: rgb(240, 242, 245);
    margin-bottom: 10px;
  }
  .card-quick-title{
    margin-bottom: 10px;
  }

  .card-panel {
    height: 108px;
    cursor: pointer;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, .05);
    border-color: rgba(0, 0, 0, .05);

    &:hover {
      .card-panel-icon-wrapper {
        color: #fff;
      }
      .icon-agent-add {
        background: #66D3D1;
      }
      .icon-card{
        background: #6DBCF9
      }
      .icon-add-card{
        background: #9FDE64
      }
      .icon-order{
        background:#F4516C
      }
      .icon-commission{
        background:#3FE1FE
      }
      .icon-auth{
        background:#73C04B
      }
      .icon-invoice{
        background:rgb(179, 127, 235)
      }
      .icon-control-card{
        background:#FF85C0
      }
      .icon-task{
        background:#E69C4D
      }

    }
    .icon-agent-add {
      color: #66D3D1
    }
    .icon-card{
      color: #6DBCF9
    }
    .icon-add-card{
        color: #9FDE64
    }
    .icon-order{
      color:#F4516C
    }
    .icon-commission{
      color:#3FE1FE
    }
    .icon-auth{
      color:#73C04B
    }
    .icon-invoice{
      color:#B37FEB
    }
    .icon-control-card{
      color:#FF85C0
    }
    .icon-task{
      color:#E69C4D
    }

    .card-panel-icon-wrapper {
      float: left;
      margin: 14px 0 0 14px;
      padding: 16px;
      transition: all 0.38s ease-out;
      border-radius: 6px;

      box-sizing: border-box;
      align-items: center;
      flex-direction: column;
      display: flex;
      outline: none;
      
    }

    .card-panel-icon {
      float: left;
      font-size: 48px;
    }

    .card-panel-description {
      float: right;
      font-weight: bold;
      margin: 26px;
      margin-left: 0px;

      .card-panel-text {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        margin-bottom: 12px;
      }

      .card-panel-num {
        font-size: 20px;
      }
    }
  }
}

.card-panel-icon-wrapper {
    float: none !important;
    width: 100%;
    height: 100%;
    margin: 0 !important;

    .svg-icon {
      display: block;
      margin: 2px auto !important;
      float: none !important;
    }
}
//投诉
.processingData{
  width: 100%;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  .processingData-left{
    width: 74%;
    height: 180px;
    border: 1px solid #e7eaf0;
    background-color: #fff;
    display: flex;
    align-items: center;
    .shuju{
      text-align: center;
      width: 33%;
      height: 130px;
      .p1{
        color: #333;
      }
      .p2{
        height: 55px;
        line-height: 55px;
        margin-top: 15px;
        border-right: 3px solid #e0e0e0;
      }
      .p3{
        height: 30px;
        line-height: 30px;
        font-size: 16px;
        color: #999;
        margin-top: 5px;
      }
    }
  }
  .processingData-right{
    width: 25%;
    height: 180px;
    border: 1px solid #e7eaf0;
    background-color: #fff;
    p{
      height: 20px;
      line-height: 20px;
      color: #999;
      margin: 30px 0px 0px 30px;
    }
  }
}
.flex-container {
  display: flex; // 使用 flex 布局
  gap: 20px; // 设置子元素之间的间距
  .box-card{
    background-color: #fff;
  }
}

.flex-item {
  flex: 1; // 子元素平均分配容器宽度
  min-width: 0; // 防止内容溢出导致宽度无法收缩
}
.refresh-icon {
  font-size: 22px;
  float: right;
  cursor: pointer;
  // margin-left: 10px;
  margin-left: auto;
}
.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.title-wrapper {
  display: flex;
  flex-direction: column;
  .main-title{
    font-weight: bolder;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 160px;

  }
}

.sub-title {
  font-size: 12px;
  color: #666;
  margin-top: 4px;
}
</style>
